<template>
  <Modal
    :modal="modal"
    :titleIcons="[]"
    :width="$vuetify.breakpoint.mdAndUp ? '800' : ''"
    title="Informe o Endereço"
    @close="$emit('close')"
    @save="save"
    :loading="loading"
  >
    <v-form v-model="valid" ref="form">
      <v-row wrap>
        <v-col cols="12" md="5" class="py-0">
          <v-autocomplete
            v-model="clienteEndereco.titulo"
            :items="tiposEndereco"
            return-object
            item-text="descricao"
            label="Tipo"
            no-data-text="Nenhum registro encontrado"
            @change="changeTipoEndereco"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8" class="py-0">
          <v-text-field
            v-model="clienteEndereco.logradouro"
            label="Endereco"
            :autofocus="modal"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-text-field
            v-model="clienteEndereco.numero"
            label="Número"
            :rules="[rules.required]"
        ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
          v-model="clienteEndereco.complemento"
          label="Complemento"
        ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            v-model="clienteEndereco.ponto_referencia"
            label="Ponto Referência"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-text-field
          v-model="clienteEndereco.bairro"
          label="Bairro"
          :rules="[rules.required]"
        ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-text-field
            v-model="clienteEndereco.cidade"
            label="Cidade"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="py-0">
          <v-text-field
            v-model="clienteEndereco.uf"
            label="UF"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="py-0">
          <v-text-field
            v-model="clienteEndereco.cep"
            label="CEP"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/shared/Modal';
import ClienteEndereco from '@/domain/ClienteEndereco';

export default {
  name: 'ModalClienteEndereco',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    editClienteEndereco: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal
  },
  data: () => ({
    loading: false,
    valid: true,
    clienteEndereco: new ClienteEndereco(),
    rules: {
      required: v => !!v || 'Campo obrigatório'
    }
  }),
  watch: {
    modal(value) {
      if (!value) this.clienteEndereco = new ClienteEndereco();
    },
    editClienteEndereco(value) {
      if (value) this.clienteEndereco = value;
    }
  },
  computed: {
    ...mapGetters(['tiposEndereco'])
  },
  methods: {
    changeTipoEndereco(tipo) {
      this.clienteEndereco.id_tipo_endereco = tipo.id_tipo_endereco;
      this.clienteEndereco.titulo = tipo.descricao;
    },
    save() {
      if (this.$refs.form.validate()) {
        if (!this.editClienteEndereco) {
          this.$emit('save', this.clienteEndereco);
        } else {
          this.$emit('update', this.clienteEndereco);
        }
      }
    }
  }
}
</script>

<style>

</style>